<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <FormItem label="标题" prop="title">
          <Input v-model="formValidate.title" placeholder="输入内容标题"></Input>
        </FormItem>

        <FormItem label="副标题">
          <Input v-model="formValidate.subTitle" placeholder="输入副标题"></Input>
        </FormItem>

        <FormItem label="开启直播">
          <RadioGroup v-model="formValidate.isLive">
              <Radio :label="0">否</Radio>
              <Radio :label="1">是</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="直播代码" v-if="formValidate.isLive==1">
          <Input v-model="formValidate.liveCode" placeholder="请输入直播代码"></Input>
        </FormItem>
        
        <FormItem label="分类" prop="category">
          <Select v-model="formValidate.category" placeholder="选择分类">
            <Option value="classic_case">典型案例</Option>
            <Option value="work_briefing">工作简报</Option>
          </Select>
        </FormItem>

        <FormItem label="摘要" prop="articleAbstract">
          <Input v-model="formValidate.articleAbstract" type="textarea" :autosize="false" :rows="5" placeholder="请输入摘要"></Input>
        </FormItem>

        <FormItem label="内容" prop="content">
          <!-- <Input v-model="formValidate.desc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input> -->
          <div style="border: solid 1px #ccc; border-radius: 4px;">
            <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editorRef"
            :defaultConfig="toolbarConfig"
            :mode="mode"
          />
          <Editor
            style="height: 360px; overflow-y: hidden;"
            v-model="formValidate.content"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="handleCreated"
          />
          </div>
        </FormItem>

        <FormItem label="封面" prop="">
          <Upload :action="uploadUrl" name="file" :on-success="handleUpload" :on-remove="handleRemove">
            <Button icon="ios-cloud-upload-outline">上传封面</Button>
          </Upload>
        </FormItem>


        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import global from '@/utils/global'
import axios from 'axios'
export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread,
    Editor,
    Toolbar
  },

  setup() {
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()

    // 内容 HTML
    const valueHtml = ref('')

    //模拟 ajax 异步获取内容
    onMounted(() => {
        // setTimeout(() => {
        //     valueHtml.value = ''
        // }, 1500)
    })

    const toolbarConfig = {}
    const editorConfig = {
      placeholder: '请输入内容...',
      MENU_CONF:{
        uploadImage:{
          server: global.restUrl + '/api/web/upload/v1.0/picture',
          fieldName: 'file'
        }
      }
    }

    // 组件销毁时，也及时销毁编辑器
    onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor // 记录 editor 实例，重要！
    }

    return {
      editorRef,
      valueHtml,
      mode: 'default', // 或 'simple'
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },

  data () {
      return {
        user: null,

        uploadUrl: global.restUrl + '/api/web/upload/v1.0/picture',
        formValidate: {
          title: '',
          subTitle:'',
          isLive: 0,
          liveCode:'',
          category: '',
          articleAbstract: '',
          content: '',
          cover: ''
        },
        ruleValidate: {
          title: [
            { required: true, message: '内容标题不能为空', trigger: 'blur' }
          ],

          category: [
            { required: true, message: '请选择分类', trigger: 'change' }
          ],

          articleAbstract: [
            { required: true, message: '摘要不能为空', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', min: 20, message: '内容至少20个字', trigger: 'blur' }
          ]
        }
      }
    },
    mounted() {
      this.initUser()
      this.getArticleById()
    },
    methods: {
      //初始化用户信息
      initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

      //获取文章详情
      getArticleById() {
        let vm = this
        let id = this.$route.query.id
        axios({
          method: 'post',
          url: global.restUrl + '/api/web/article/v1.0/detail',
          data: {
            id: id,
          }
        }).then(function (response) {
          let success = response.data.success
          if(success) {
            let data = response.data.data
            vm.formValidate = data
          }
        });
      },

      //表单提交
      handleSubmit (name) {
        let vm= this
        this.$refs[name].validate((valid) => {
          if (valid) {
            //console.log(this.formValidate)
            //this.$Message.success('Success!');
            axios({
              method: 'post',
              url: global.restUrl+'/api/manage/article/v1.0/save',
              data: this.formValidate,
              headers: {
                token: vm.user.token
              }
            })
            .then(function (response) {
              let success = response.data.success
              if(success) {
                vm.$Message.success({
                  content: response.data.message,
                  duration: 3,
                  closable: true,
                  onClose: (function() {
                    vm.$router.push({path: '/admin/article/all'});
                  })
                });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          } else {
            this.$Message.error('Fail!');
          }
        })
      },
      handleReset (name) {
        this.$refs[name].resetFields();
      },

      //上传成功
      handleUpload(response) {
        if(response.errno==0) {
          this.formValidate.cover = response.data.url
        }
      },
      
      //文件移除
      handleRemove() {
        this.formValidate.cover = ''
      }
    }
}
</script>
